import * as ReactGA from 'react-ga'

export const isIntervuRedirect = query =>
  query.get('redirect_uri') && query.get('redirect_uri').includes('intervu')

export const sendIntervuAnalyticsEvent = (category, action) =>
  ReactGA.ga('intervu.send', 'event', category, action)



// WEBPACK FOOTER //
// ./src/utils/analytics.js